import { Pipe, PipeTransform } from '@angular/core';

import { Metafield } from '../models';

@Pipe({ name: 'metafieldsValue' })
export class ShopifyMetaFieldsPipe implements PipeTransform {
  transform(value: Metafield[], field: string): any {
    const getLabel = value.find(m => m?.key === field);

    return getLabel?.value;
  }
}
